import { Box, Grid, Typography } from "@mui/material";

const NoLoansFound = () => {
  return (
    <Grid className="no-loan-found" spacing={2}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "350px",
          textAlign: "center",
          p: 3,
        }}
        className="card-contaner"
      >
        <Typography
          sx={{
            fontSize: "25px",
            fontWeight: 600,
            color: "#646464ff",
          }}
        >
          No Loans
        </Typography>
        <Typography
          sx={{
            color: "#6c757d",
            mb: 4,
            fontSize: "13px",
            fontWeight: 500,
          }}
        >
          Oops! You dont have any loan.
        </Typography>

        {/* <Button
          variant="contained"
          sx={{
            backgroundColor: "#00b3b5",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#009a9b",
            },
            fontWeight: "600",
            fontSize: "13px",
            px: 4,
            py: 1.5,
            borderRadius: 2,
            textTransform: "capitalize",
          }}
          onClick={() => {
            navigate();
          }}
        >
          Apply for New Loan
        </Button> */}
      </Box>
    </Grid>
  );
};

export default NoLoansFound;
